<div class="jumbotron text-center">
  <div class="container">
    <div class="row">
      <div class="col-sm-12" style="text-align:left">
        <button type="button" class="btn btn-outline-primary" (click)="open(content)">Create New User</button>
      </div>
    </div>
    <br>
      <div class="row">
        <div class="col-sm-12 table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th>#</th>
                <th>Username</th>
                <th>email</th>
                <th>mobile</th>
                <th>user type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (list_length == 0) {
                <tr>
                  <td colspan="8">No data found</td>
                </tr>
              }
              @for (user of users; track user; let i = $index) {
                <tr>
                  <td>{{ i+1 }}</td>
                  <td>
                    @if (user.role=='admin') {
                      <span>{{user.username}}</span>
                    }
                    @if (user.role!='admin') {
                      <a href="#" [routerLink]="['/employees']" [queryParams]="{ id: user.id }" style="text-decoration: none;">{{user.username}}</a>
                    }
                  </td>
                  <td>{{user.email}}</td>
                  <td>{{user.phone}}</td>
                  <td>{{user.role}}</td>
                  <td style="white-space: nowrap; width: 1%;">
                    @if (utility.isAdmin()) {
                      <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                        >
                        <button disabled type="button" class="btn btn-danger"
                        (click)="onDelete(user.id)">delete</button>
                        <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-secondary"
                        (click)="changeP(content3, user.id)">change password</button>
                        <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-info"
                        (click)="edit(content2, user.id)">edit</button>
                        @if (user.is_active == 0) {
                          <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-success"
                          (click)="onEnable(user.id)">Enable</button>
                        }
                        @if (user.is_active == 1) {
                          <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-warning"
                          (click)="onDisable(user.id)">Disable</button>
                        }
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-md-8 col-lg-9" style="text-align:left">
          <ngb-pagination [collectionSize]="users.length" [(page)]="page" [maxSize]="10" [rotate]="true"
          [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">New User</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input type="text" class="form-control" [(ngModel)]="user.email" id="email" placeholder="add email">
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input type="password" class="form-control" [(ngModel)]="user.password" id="password"
          placeholder="add password">
      </div>
      <div class="mb-3">
        <label class="form-label" for="username">Username</label>
        <input type="text" class="form-control" [(ngModel)]="user.username" id="username"
          placeholder="add name in english">
      </div>
      <div class="mb-3">
        <label class="form-label" for="phone">Mobile</label>
        <input type="number" class="form-control" [(ngModel)]="user.phone" id="phone"
          placeholder="add mobile number">
      </div>
      <div class="mb-3">
        <label class="form-label" for="status">Role</label>
        <select class="form-select" [(ngModel)]="user.role_id">
          @for (role of roles; track role) {
            <option [ngValue]='role.id'>{{ role.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnSubmit(employeeContent)">Add</button>
    </div>
  </ng-template>

  <ng-template #content2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Edit User</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label" for="email">email</label>
        <input type="text" class="form-control" [(ngModel)]="new_user.email" id="email">
      </div>
      <div class="mb-3">
        <label class="form-label" for="username">Username</label>
        <input type="text" class="form-control" [(ngModel)]="new_user.username" id="username" disabled>
      </div>
      <div class="mb-3">
        <label class="form-label" for="phone">Mobile</label>
        <input type="number" class="form-control" [(ngModel)]="new_user.phone" id="phone">
      </div>
      <div class="mb-3">
        <label class="form-label" for="status">Role</label>
        <select class="form-select" [(ngModel)]="new_user.role_id">
          @for (role of roles; track role) {
            <option [ngValue]='role.id'>{{ role.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(new_user_id)">Edit</button>
    </div>
  </ng-template>
  <ng-template #content3 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Reset Password</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label" for="email">email</label>
        <input type="text" class="form-control" [(ngModel)]="user_password.email" id="email" disabled>
      </div>
      <div class="mb-3">
        <label class="form-label" for="password">New Password</label>
        <input type="password" class="form-control" [(ngModel)]="user_password.password" id="password"
          placeholder="add password">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnChangePassword(user_password.id)">OK</button>
    </div>
  </ng-template>

  <ng-template #employeeContent let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Employee Details</h4>

      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input type="text" class="form-control" [(ngModel)]="employee.name" id="name" placeholder="Full Name">
      </div>
      <div class="mb-3">
        <label for="id_number" class="form-label">Id Number</label>
        <input type="text" class="form-control" [(ngModel)]="employee.id_number" id="id_number"
          placeholder="123456789">
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="country" class="form-label">Country</label>
            <input type="text" class="form-control" [(ngModel)]="employee.country" id="country"
              placeholder="Employee Nationality">
          </div>
          <div class="col">
            <label for="gender" class="form-label">Gender</label>
            <select class="form-select" [(ngModel)]="employee.gender" id="gender">
              <option value="0">--- Select ---</option>
              <option value='male'>Male</option>
              <option value='female'>Female</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="basic_salary" class="form-label">Basic Salary</label>
        <input type="number" class="form-control" [(ngModel)]="employee.basic_salary" id="basic_salary">
      </div>
      <div class="mb-3">
        <label for="bank_name" class="form-label">Bank Name</label>
        <input type="text" class="form-control" [(ngModel)]="employee.bank_name" id="bank_name"
          placeholder="Bank Name">
      </div>
      <div class="mb-3">
        <label for="account_number" class="form-label">Bank Account No.</label>
        <input type="number" class="form-control" [(ngModel)]="employee.account_number" id="account_number"
          placeholder="023456789123451">
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="birth_date" class="form-label">Date of Birth</label>
            <input type="date" class="form-control" [(ngModel)]="employee.birth_date" id="birth_date">
          </div>
          <div class="col">
            <label for="id_expiry_date" class="form-label">Id Expiry Date</label>
            <input type="date" class="form-control" [(ngModel)]="employee.id_expiry_date" id="id_expiry_date">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnAddDetails()" [disabled]="employee.name==null">Save</button>
    </div>
  </ng-template>